import { render, staticRenderFns } from "./AvatarButton.vue?vue&type=template&id=ae5b7d4c&scoped=true&"
import script from "./AvatarButton.vue?vue&type=script&lang=js&"
export * from "./AvatarButton.vue?vue&type=script&lang=js&"
import style0 from "./AvatarButton.vue?vue&type=style&index=0&id=ae5b7d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b7d4c",
  null
  
)

export default component.exports